import axios from '../utils/axiosClient';
import endpoints from './endpoints';
const { login, logout, closeOtherSessions } = endpoints;

const logIn = async (username: string, password: string) => {
  const data = { username, password };

  try {
    const response = await axios.post(login, data);
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const logOut = async () => {
  try {
    const response = await axios.post(logout);
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const closeSessions = async () => {
  try {
    const response = await axios.post(closeOtherSessions);
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const authServices = {
  logIn,
  logOut,
  closeSessions,
};

export default authServices;
